<template>
    <div class="multiselect-wrapper">
        <Multiselect
            :placeholder="
                selectedLocations.length > 0
                    ? $t('reporting.commonLabels.locations')
                    : $t('reporting.commonLabels.allLocations')
            "
            :multiple="true"
            :close-on-select="false"
            :options="locations"
            label="name"
            track-by="name"
            :value="selectedLocations"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :limit="10"
            @input="updateLocations"
        >
            <span slot="noResult">{{ $t('common.noSearchResults') }}</span>
        </Multiselect>
    </div>
</template>

<script>
import Multiselect from 'moxa-vue-multiselect';
import { transformArrayToOptions, transformOptionsToArray } from '../../widgetHelpers';

export default {
    components: { Multiselect },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Array,
            required: true,
        },
    },

    computed: {
        /**
         * Returns a list of currently selected locations for Multiselect component
         * @return {{ name: string, value: string}[]}
         */
        selectedLocations() {
            return transformArrayToOptions(this.value);
        },
    },

    methods: {
        /**
         * Emits update event for "locations" field in widget configuration
         * @param {{ name: string, value: string}[]} selectedOptions
         */
        updateLocations(selectedOptions) {
            this.$emit('input', transformOptionsToArray(selectedOptions));
        },
    },
};
</script>
